module.exports = __webpack_public_path__ + "static/img/funny_17.04414ecf.jpg";